export default __webpack_public_path__ + "static/1027-c8b3c46b7e5112a3c93c4bc6a57f2e6d.gif";